export const MUNICIPAL_PROPERTY_REGISTER_YEAR_BOUNDS = {
    min: 1000,
    max: 9999,
};
